export enum PaymentStatus {
    CHECKING,
    UNPAID,
    PAID_YEARLY,
    PAID_MONTHLY,
}
